/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import PersonalData from './Dnd/PersonalData';
import SensitivePersonalData from './Dnd/SensitivePersonalData';
import { useEffect } from 'react';
import { checkValidForm } from './Step1';
import BtnSave from './BtnSave';

const Step2 = (props) => {
    const { t } = useTranslation();

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                props.setStep2(true);
            })
            .catch(() => props.setStep2(false));
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.disclosurePersonalData) {
            onValuesChange(null, props.previewData?.disclosurePersonalData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'discloseToOtherPersonTh',
            'retentionPeriodTh',
            'transferPersonalDataTh',
            // 'personalDataOption',
            // 'sensitivePersonalDataOption',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep2(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('policy.des2')}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="disclosurePersonalData"
                layout="vertical"
                form={props?.form}
                initialValues={{
                    personalDataOptionSequence: [],
                    sensitivePersonalDataOptionSequence: [],
                }}
                onValuesChange={onValuesChange}
            >
                <Form.Item
                    className="mt-4"
                    name={'discloseToOtherPersonTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.discloseToOtherPersonTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'discloseToOtherPersonEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.discloseToOtherPersonEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodEnPl')}
                    />
                </Form.Item>
                <span className="ant-col ant-form-item-label">
                    <label>
                        <span className="text-[21px] font-bold">
                            {t('policy.personalData')}
                        </span>
                    </label>
                </span>
                <PersonalData form={props?.form} />
                <SensitivePersonalData form={props?.form} />
                <Divider />
                <Form.Item
                    className="mt-4"
                    name={'retentionPeriodTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.retentionPeriodTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    initialValue=""
                >
                    <Editor placeholder={t('policy.retentionPeriodThPl')} />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'retentionPeriodEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.retentionPeriodEn')}
                        </span>
                    }
                    initialValue=""
                >
                    <Editor placeholder={t('policy.retentionPeriodEnPl')} />
                </Form.Item>
                <Divider />
                <Form.Item
                    className="mt-4"
                    name={'transferPersonalDataTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.transferPersonalDataTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    initialValue=""
                >
                    <Editor
                        placeholder={t('policy.transferPersonalDataThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'transferPersonalDataEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.transferPersonalDataEn')}
                        </span>
                    }
                    initialValue=""
                >
                    <Editor
                        placeholder={t('policy.transferPersonalDataEnPl')}
                    />
                </Form.Item>

                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                            className="ml-4"
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step2;
